export default __webpack_public_path__ + "static/media/x2.fede1a92.png";